import AxiosService from './AxiosService';

class BusinessService {
  constructor() {
    if (!BusinessService.instance) {
      BusinessService.instance = this;
    }
    return BusinessService.instance;
  }

  serviceEndpoint = 'business';

  createNewBusiness = async (payload) => {
    const response = await AxiosService.post(
      `${this.serviceEndpoint}/new`,
      payload
    );
    return response.data;
  };
}

const instance = new BusinessService();
Object.freeze(instance);

export default instance;
